import { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/billing-credit-plan'
import Menu from '/components/billing/nav-menu'
import Application from '../components/billing/credit-plan'

const BillingCongtractApplication = () => {

  const navigate = useNavigate()
  const { user } = useContext(AppContext)
  
  if (user?.permissions.client_admin) return (
    <PageWrapper title="Billing - Credit Plan" HelpText={HelpText} heading="Apply for a credit plan" menu={<Menu />}>
      <div className='flex flex-row w-full'>
        <Application />
      </div>      
    </PageWrapper>
  )
  else navigate("/")
}

export default BillingCongtractApplication